export const isDevMode = window.location.hostname === 'localhost';
